import { useEffect, useState } from "react";
import {FaAngleDoubleUp} from "react-icons/fa"
export const ScrollToTop=()=>{
    const [showbutton,setshowbutton]=useState(false);
    useEffect(()=>{
        window.addEventListener('scroll',()=>{
            if(window.scrollY>900){
                setshowbutton(true);
               }else{
                setshowbutton(false);
               }
        }) 
    },[])
    const ScrollTop=()=>{
        window.scrollTo({
          top:0,
          behavior:"smooth"
        })
      }
      return (
        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"stretch"}}>{showbutton && <FaAngleDoubleUp style={{position:"fixed",height:"60px",width:'60px',fontWeight:"bold",marginTop:"200px",cursor:"pointer"}} onClick={ScrollTop} />}</div>
      )
}